/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { remoteSessionClientsGetNewClientCallbackUrl } from "../funcs/remoteSessionClientsGetNewClientCallbackUrl.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { NewClientCallbackURLResult } from "../models/components/newclientcallbackurlresult.js";
import {
  GetNewRemoteSessionClientCallbackUrlRequest,
  GetNewRemoteSessionClientCallbackUrlSecurity,
} from "../models/operations/getnewremotesessionclientcallbackurl.js";
import { unwrapAsync } from "../types/fp.js";
export type NewRemoteSessionClientCallbackUrlQueryData =
  NewClientCallbackURLResult;

export function prefetchNewRemoteSessionClientCallbackUrl(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetNewRemoteSessionClientCallbackUrlRequest | undefined,
  security?: GetNewRemoteSessionClientCallbackUrlSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildNewRemoteSessionClientCallbackUrlQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildNewRemoteSessionClientCallbackUrlQuery(
  client$: GramCore,
  request?: GetNewRemoteSessionClientCallbackUrlRequest | undefined,
  security?: GetNewRemoteSessionClientCallbackUrlSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<NewRemoteSessionClientCallbackUrlQueryData>;
} {
  return {
    queryKey: queryKeyNewRemoteSessionClientCallbackUrl({
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function newRemoteSessionClientCallbackUrlQueryFn(
      ctx,
    ): Promise<NewRemoteSessionClientCallbackUrlQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(remoteSessionClientsGetNewClientCallbackUrl(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyNewRemoteSessionClientCallbackUrl(
  parameters: {
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "remoteSessionClients",
    "getNewClientCallbackUrl",
    parameters,
  ];
}
